import React, { useEffect } from 'react';
import { Navigate } from 'react-router-dom';
import { useDiagnosesPageDispatch } from '../contexts/DiagnosesPageContext';
import { usePatientInfoDispatch } from '../contexts/CurrentPatientInfoContext';
import { useLLMDiagnose } from '../contexts/LLMDiagnoseContext';
import { useTreatmentsPageDispatch } from '../contexts/TreatmentsPageContext';
import { useDosagesPageDispatch } from '../contexts/DosagesPageContext';
import { useSoapNotes } from '../contexts/SoapNotesContext';

const DiagnoseHomePage = () => {
  const dispatchPageDiagnoses = useDiagnosesPageDispatch();
  const dispatchPatientInfo = usePatientInfoDispatch();
  const dispatchPageTreatments = useTreatmentsPageDispatch();
  const dispatchPageDrugDosages = useDosagesPageDispatch();
  const { setSoapNotes, setSoapNotesGeneratedAt } = useSoapNotes();
  const { setExtractedSymptoms, setExtractedAnimal, setFreeText } =
    useLLMDiagnose();
  // on init, reset all diagnose data
  useEffect(() => {
    dispatchPageDiagnoses({ type: 'resetAll' });
    dispatchPatientInfo({ type: 'resetPatientInfo' });
    setExtractedSymptoms({});
    setFreeText('');
    setExtractedAnimal(null);
    setSoapNotes('');
    setSoapNotesGeneratedAt(undefined);
    dispatchPageTreatments({ type: 'reset' });
    dispatchPageDrugDosages({ type: 'reset' });
  }, []); // eslint-disable-line
  return <Navigate to="/work/patient/test/visit/test/diagnoses" />;
};

export default DiagnoseHomePage;
